import type { CompanyInfo, GenerateSearchQueryIdRequest, GenerateSearchQueryIdResponse } from '../types';

export const CompanyApi = Symbol('CompanyApi');

export interface CompanyApi {
    getInfo(id: string, type: string): Promise<CompanyInfo>
    generateSearchQueryId(data: GenerateSearchQueryIdRequest): Promise<GenerateSearchQueryIdResponse>
}
